// FT-066: per-component subscription tracking + auto-unsubscribe.
// Handlers live on the returned subscription object (per-instance) → no name collisions.
import { subscribe as cableSubscribe } from "@/cable";

export default {
  beforeCreate() {
    this._cableSubs = []; // non-reactive
  },
  methods: {
    $cableSubscribe(params, handlers) {
      const sub = cableSubscribe(params, handlers);
      this._cableSubs.push(sub);
      return sub;
    },
    $cableUnsubscribe(sub) {
      if (!sub) return;
      // Double-call safe: only act if this sub is still tracked (un-tracked ⇒
      // already unsubscribed by a prior call or beforeDestroy → no-op).
      if (!this._cableSubs.includes(sub)) return;
      sub.unsubscribe();
      this._cableSubs = this._cableSubs.filter((s) => s !== sub);
    },
  },
  beforeDestroy() {
    this._cableSubs.forEach((s) => s.unsubscribe());
    this._cableSubs = [];
  },
};
